// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.product-type-attributes-table[data-v-97b4110c] {\n  margin: 0 0 12px 25%;\n  width: 75%;\n}\n", ""]);
// Exports
module.exports = exports;
